import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// settings/tippiBilling: Tippis egne fakturaopplysninger (brukes på gebyrfakturaer).
export function useTippiBilling() {
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => onSnapshot(
    doc(db, 'settings', 'tippiBilling'),
    snap => { setBilling(snap.exists() ? snap.data() : null); setError(null); setLoading(false); },
    err => { console.error('useTippiBilling:', err); setBilling(null); setError(err); setLoading(false); },
  ), []);

  return { billing, loading, error };
}
